<template>
  <div class="card card-custom mt-5">
    <div class="card-header">
      <div class="card-title">
        <h3 class="card-label">Thông tin quản lý</h3>
      </div>
    </div>
    <div class="card-body">
      <b-row>
        <b-col md="6">
          <b-form-group label="Giao cho">
            <div
              v-if="!canAssign && mode !== MODE.VIEW"
              v-b-tooltip.hover.top="
                'Bạn không có quyền gán Lead cho nhân viên khác'
              "
            >
              <AutoSuggest
                :model="leadForm.assignedUser?.fullName || ''"
                :suggestions="employeeSuggestions"
                :placeholder="'Người giao cho'"
                :suggestion-name="'label'"
                :disabled="true"
                @change="searchEmployees"
                @select="selectEmployee"
              >
                <div slot="custom" slot-scope="{ suggestion }">
                  {{ suggestion.item.label }} - {{ suggestion.item.code }}
                </div>
              </AutoSuggest>
            </div>
            <AutoSuggest
              v-else
              :model="leadForm.assignedUser?.fullName || ''"
              :suggestions="employeeSuggestions"
              :placeholder="'Người giao cho'"
              :suggestion-name="'label'"
              :disabled="mode === MODE.VIEW"
              @change="searchEmployees"
              @select="selectEmployee"
            >
              <div slot="custom" slot-scope="{ suggestion }">
                {{ suggestion.item.label }} - {{ suggestion.item.code }}
              </div>
            </AutoSuggest>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Chiến dịch" label-for="campaign">
            <b-input
              v-model.trim="leadForm.campaign"
              :readonly="mode === MODE.VIEW"
              placeholder="Nhập tên chiến dịch"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <b-form-group
            label="Mô tả đánh giá"
            label-for="evaluationDescription"
          >
            <b-textarea
              v-model.trim="leadForm.evaluationDescription"
              rows="4"
              :readonly="mode === MODE.VIEW"
              placeholder="Nhập mô tả đánh giá"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import AutoSuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';

import UserModel from '@/core/models/User.model';
import { LeadModel } from '@/core/models/Lead.model';
import { UserService } from '@/core/api/user/user.service';

import { permissionMixin } from '@/view/mixins/permission.mixins';

import * as ENUM from '@/utils/enum';

export default {
  name: 'ManagementInformation',
  mixins: [permissionMixin],
  components: {
    AutoSuggest,
  },
  data() {
    return {
      MODE: ENUM.MODE,
      PERMISSIONS: ENUM.PERMISSIONS,
      employeeSuggestions: [],
      searchTimeout: null,
    };
  },
  props: {
    leadForm: {
      type: [Object, LeadModel],
      required: false,
    },
    mode: {
      type: String,
      required: false,
      default: ENUM.MODE.VIEW,
    },
  },
  computed: {
    canAssign() {
      return this.hasPermission(this.PERMISSIONS.LEAD_ASSIGN);
    },
  },
  methods: {
    updateField(field, value) {
      this.$emit('update-field', { field, value });
    },

    selectEmployee(option) {
      if (option?.item) {
        this.updateField('assignedUserId', option.item.id);
      } else {
        this.updateField('assignedUserId', null);
      }
    },

    searchEmployees(searchQuery) {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }

      this.searchTimeout = setTimeout(() => {
        this.performSearch(searchQuery);
      }, 300);
    },

    async performSearch(searchQuery) {
      this.employeeSuggestions = [];

      if (!searchQuery || searchQuery.length < 2) {
        return;
      }

      try {
        const { data } = await UserService.smartSearch({
          keyword: searchQuery,
          limit: 5,
        });

        const employees = UserModel.fromJsonArray(data?.data.data) || [];
        this.employeeSuggestions = employees.map((employee) => ({
          id: employee.id,
          label: employee.fullName,
          name: employee.fullName,
          code: employee.code,
        }));
      } catch (error) {
        console.error('Error loading employees:', error);
      }
    },
  },
};
</script>
